import { Elk, ELKDocument } from '../models/elk';
import {
  DOCUMENT_TYPE,
  DocumentFields,
  dulInitialState,
  PASSPORT_STATUS,
} from '../constants/document';
import { createSelector } from 'reselect';
import childrenSerializer from '../helpers/childrenSerializer';

export const applicantDulSerializer = (
  passport: ELKDocument
): DocumentFields => {
  if (!passport) return dulInitialState;
  const {
    number,
    issued_by: issuer,
    issued_on: issueDate,
    division_code: divisionCode,
  } = passport;
  const disableDul = !!number;

  const setField = (value) => {
    return { value: value || '', disabled: !!value };
  };

  return {
    type: {
      value: DOCUMENT_TYPE.PASSPORT_RF,
      disabled: disableDul,
    },
    number: setField(number),
    issuer: setField(issuer),
    issueDate: setField(issueDate),
    divisionCode: setField(divisionCode),
    birthCertificate: false,
    status: PASSPORT_STATUS.VALID,
  };
};

export const getElk: (state: { elk: Elk }) => Elk = (state) => state.elk;

export const getApplicantElkDocument = createSelector(getElk, (elk) =>
  applicantDulSerializer(elk.passport_rf)
);

export const getElkChildren = createSelector(getElk, (elk) =>
  childrenSerializer(elk)
);
